import React from 'react';
import cx from 'classnames';
import BenefitsModal from '../../../../../../BenefitsModal/BenefitsModal';
import displayCurrency from '../../../../../../../../../helpers/displayCurrency';
import { Icon } from '../../../../../../../../../common/components';
import './PremiumRow.scss';

const PreviousPremium = ({ before, current }) => {
  if (before === current) {
    return null;
  }
  return <span className="previous-premium">{displayCurrency(before)}</span>;
};
const PremiumSelect = ({
  handleSelectPremium,
  premium,
  selectedPremiumId,
  hasErrors,
}) => {
  if (!premium) {
    return null;
  }
  const onSelectPremium = () => {
    if (!hasErrors) {
      handleSelectPremium(premium.scheme.id);
    }
  };

  const isSelected = premium.scheme.id === selectedPremiumId;
  // const isSelected = selectedPremiumId.includes(premium.scheme.id);
  const iconClass = isSelected ? 'check-circle' : 'circle';
  const grossBeforeAdjustment = premium.premium_before_adjustments.gross;
  const { gross } = premium.premium;
  return (
    <div
      onClick={onSelectPremium}
      onKeyPress={onSelectPremium}
      tabIndex="-1"
      role={'button'}
      className={cx('premium', {
        'premium-selected': isSelected,
      })}
    >
      <PreviousPremium before={grossBeforeAdjustment} current={gross} />
      <div>
        <span className={'gross'}>{displayCurrency(premium.premium.gross)}</span>
        <Icon name={iconClass} style="far" />
      </div>
    </div>
  );
};
const ErrorMessages = ({ declines, errors }) => {
  if (!declines.length && !errors.length) {
    return null;
  }
  const declineMessages = declines.map((decline) => decline.reason);
  const errorMessages = errors.map((error) => error);
  const allMessages = declineMessages.concat(errorMessages);
  return (
    <div className="quote-error-box">
      <span>
        NOTE: &nbsp;
        {}
        {allMessages.map((error) => {
          return error;
        })}
      </span>
    </div>
  );
};
const PremiumRow = ({
  premium,
  coverLevel,
  isMta,
  selectedPremiumId,
  handleSelectPremium,
}) => {
  const inPatientBenefit = premium.benefits.find(
    (benefit) => benefit.display_name === 'inpatient',
  );
  const outPatientBenefit = premium.benefits.find(
    (benefit) => benefit.display_name === 'outpatient',
  );
  const accidentalDeath = premium.benefits.find(
    (benefit) => benefit.display_name === 'accident-death',
  );
  const errors = premium.errors || [];
  const declines = premium.declines || [];

  return (
    <>
      <div className={'pa-premium-row'}>
        <div className="cell" style={{ marginBottom: '5px' }}>
          <img
            className="img-responsive"
            src={premium.scheme.logo}
            alt={premium.scheme.insurer}
          />
        </div>
        <div className={`cell cover-level--${coverLevel.toLowerCase()}-scheme`}>
          <span>{coverLevel}</span>
        </div>

        <div className="cell">
          <div className="benefit">
            {inPatientBenefit ? inPatientBenefit.text : 'Nil'}
          </div>
        </div>
        <div className="cell">
          <div className="benefit">
            {outPatientBenefit ? outPatientBenefit.text : 'Nil'}
          </div>
        </div>
        <div className="cell">
          <div className="benefit">{accidentalDeath ? accidentalDeath.text : 'Nil'}</div>
        </div>
        <div className="cell">
          <BenefitsModal scheme={premium.scheme} benefits={premium.benefits} />
        </div>
        <div className="cell">
          <div>
            <PremiumSelect
              premium={premium}
              selectedPremiumId={selectedPremiumId}
              handleSelectPremium={handleSelectPremium}
              isMta={isMta}
              hasErrors={!!errors.length || !!declines.length}
            />
          </div>
        </div>
      </div>
      <ErrorMessages declines={declines} errors={errors} />
    </>
  );
};

export default PremiumRow;
